import React from 'react';
import { connect } from 'react-redux';
import { func, bool, shape, object, string } from 'prop-types';
import { reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import Radium from 'radium';
import { UTButton, UTLabel } from '@widergy/energy-ui';

import { gaTrackPageView } from 'services/AnalyticsService';
import { ROUTES } from 'constants/routes';
import AuthFormBox from 'app/components/AuthFormBox';
import { CHANGE_PASSWORD_FORM } from 'constants/reduxForms';
import { message } from 'utils/stringUtils';

import { actionCreators as authActions } from '../../../../../redux/authHandlers';
import { RESET_PASSWORD_TOKEN } from '../../constants';

import ChangePassword from './layout';
import styles from './styles';

class ChangePasswordContainer extends React.PureComponent {
  componentDidMount() {
    this.handleValidateToken();
    gaTrackPageView(ROUTES.SIGN_IN_CHANGE_PASSWORD);
  }

  handleValidateToken = () => {
    const parameters = new URLSearchParams(this.props.location.search);
    const resetPasswordToken = parameters.get(RESET_PASSWORD_TOKEN);
    this.props.dispatch(authActions.validateToken(resetPasswordToken));
  };

  render() {
    const { handleSubmit, loading, submitFailed, invalid } = this.props;
    return (
      <form onSubmit={handleSubmit} style={styles.container}>
        <AuthFormBox title={message('Signin:changePassword')}>
          <ChangePassword loading={loading} />
        </AuthFormBox>
        {!loading && [
          <UTButton disabled={submitFailed && invalid} key="submit" style={styles.submit} type="submit">
            {message('Signin:changePasswordAction')}
          </UTButton>,
          <Link key="goBack" style={styles.goBack} to={ROUTES.SIGN_IN}>
            <UTLabel semibold small>
              {message('Commons:back')}
            </UTLabel>
          </Link>
        ]}
      </form>
    );
  }
}

ChangePasswordContainer.propTypes = {
  location: shape({
    pathname: string.isRequired,
    state: object,
    search: string
  }),
  handleSubmit: func.isRequired,
  loading: bool,
  invalid: bool,
  submitFailed: bool
};

const mapStateToProps = store => ({
  loading: store.auth.recoveryPasswordLoading
});

export default connect(mapStateToProps)(
  reduxForm({ form: CHANGE_PASSWORD_FORM })(Radium(ChangePasswordContainer))
);
